import * as React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { TemplateSub } from "../../../components/layouts/TemplateSub";
import { Formik, Form, Field } from "formik";
import { SliderField } from "../../shared/SliderField";
import NewButton from "../../../components/uiMerge/newButton";
import { 
  UpdateAppSettingController, 
  MyAppSettingController 
} from "@njoy/controller";
import ToastMessage from "../../../hooks/useToast";
import { extractError } from "../../../utils/extractError";
import PageLoader from "src/modules/shared/PageLoader";

export const TopUplimitPage: React.FC = () => {
  const timeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <MyAppSettingController>
      {({data, loading}) => {
        if (loading || !data) {
          return <PageLoader/>;
        }

        const initialValues = {
          topUpLimit: data.myAppSetting?.topUpLimit || 0
        }

        return(
          <TemplateSub
            page={`Transaction Limit`}
          >
            <>
              <ToastContainer />

              <div className="px-[1rem] flex flex-col flex-1">
                <UpdateAppSettingController>
                  {({ submitUpdateAppSetting, loading, error, message }) => (
                    <Formik
                      initialValues={initialValues}
                      onSubmit={async (values, { setSubmitting, setErrors, resetForm }) => {
                        setSubmitting(true);
                        const errors = await submitUpdateAppSetting({ input: values });
                        setSubmitting(false);

                        if (!errors) {
                          ToastMessage("success", "Transaction limit updated!");
                          
                          timeoutRef.current = setTimeout(() => {
                            window.location.reload();
                          }, 2000);
                        } else {
                          // Map errors to Formik field errors if possible
                          if (errors && typeof errors === "object" && "topUpLimit" in errors) {
                            setErrors({ topUpLimit: (errors as any).topUpLimit });
                          }
                          ToastMessage("error", extractError(errors.errors));
                        }
                      }}
                    >
                      {({ values, setFieldValue, isSubmitting }) => (
                        <Form className="flex flex-col flex-1">
                          <div className="!w-full mt-[3rem] flex flex-col items-center gap-[1.5rem]">
                            <p className="w-full text-center text-white text-[13px] font-medium">
                              Current Transaction Limit
                            </p>
                            <p className="w-full h-[33px] [font-family:'Avenir-Light', 'Segoe UI', 'Arial', 'Roboto', sans-serif] flex flex-col justify-center text-center text-white text-[30px] font-extrabold">
                              ₦ {(values?.topUpLimit ?? 0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                              })}
                            </p>

                            <Field
                              name="topUpLimit"
                              component={SliderField}
                              min={5000}
                              max={500000}
                              step={5000}
                              value={values.topUpLimit}
                              onChange={(val: number) => setFieldValue("topUpLimit", val)}
                              className={" !w-full"}
                              classNames={{
                                root: 'topup-slider-root',
                                handle: 'topup-slider-handle',
                                track: 'topup-slider-track',
                                rail: 'topup-slider-rail'
                              }}
                            />

                            <p className=" text-center text-white text-[13px] font-medium px-[2rem]">
                              Adjust the slider to the preferred transaction limit you need. The
                              maximum limit is ₦500,000
                            </p>
                          </div>
                          
                          <div className="mt-auto mb-8">
                            <NewButton
                            fullWidth
                            variant="primary"
                            type="submit"
                            className="login-form-button"
                            loading={isSubmitting}>
                              Save changes
                            </NewButton>
                          </div>
                        </Form>
                      )}
                    </Formik>
                )}
                </UpdateAppSettingController>
              </div>
            </>
          </TemplateSub>
        )
      }}
    </MyAppSettingController>
  );
};